import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InnButton from "@/components/ds/button/Button.vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import api from "@/api";
import { PropType } from "vue";
import { Project } from "@/types";
import { useProjectStore } from "@/stores/projects";
import { useRouter } from "vue-router";
import { useUiStore } from "@/stores/ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDelete',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const uiStore = useUiStore();

const projectsStore = useProjectStore();

const deleteProject = () => {
    if (props.project) {
        api.delete(props.project, "projects").then(() => {
            if (props.project) {
                projectsStore.delete(props.project);
            }
            router.push({ name: "Projects" });
            uiStore.message("Project verwijderd...");
        });
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, { "max-width": "500" }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(IconButton, _mergeProps(activatorProps, {
        "icon-id": "trash",
        variant: "danger"
      }), {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Verwijder project ")
        ])),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(({ isActive }) => [
      _createVNode(_component_v_card, { style: {"padding":"12px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(" Wil je " + _toDisplayString(__props.project.projectName) + " verwijderen? ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(InnButton, {
                onClick: 
                            () => {
                                isActive.value = false;
                                deleteProject();
                            }
                        
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" Verwijderen ")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}
}

})